import { Typography } from "@material-ui/core";
import { OptionsMenu } from "components/OptionsMenu";
import { format } from "date-fns";
import { convertDate, reasonMap, typeMapping } from "utils";

export const getNormalColumns = options => [
  {
    field: "created",
    label: "Criado em",
    align: "center",
    disabledSort: true,
    style: { minWidth: "150px" },
    formatter: value => convertDate(new Date(value))
  },
  {
    field: "product_base",
    label: "Produto Base",
    disabledSort: true,
    style: { minWidth: "170px", maxWidth: "300px" },
    formatter: value => value?.name
  },
  {
    field: "to_be_accounted",
    label: "Contabilizar em",
    align: "center",
    disabledSort: true,
    style: { minWidth: "180px" },
    formatter: value => {
      if (value) {
        return format(new Date(value), "dd/MM/yy");
      }
      return null;
    }
  },
  {
    field: "quantity",
    label: "Movimentação",
    align: "center",
    disabledSort: true,
    style: { minWidth: "120px" },
    formatter: value => {
      if (!value) return 0;
      return new Intl.NumberFormat("pt-BR").format(value.toFixed(2));
    },
    cellStyle: data => {
      if (data.quantity < 0) {
        return { color: "red" };
      }
    }
  },
  {
    field: "current_storage",
    label: "Novo estoque",
    align: "center",
    disabledSort: true,
    style: { minWidth: "120px" },
    formatter: value => {
      if (!value) return "Não informado";
      return new Intl.NumberFormat("pt-BR").format(value.toFixed(2));
    },
    cellStyle: data => {
      if (data.current_storage < 0) {
        return { color: "red" };
      }
    }
  },
  {
    field: "type",
    label: "Tipo",
    align: "center",
    disabledSort: true,
    style: { minWidth: "140px" },
    formatter: value => value?.name
  },
  {
    field: "reason",
    label: "Motivo",
    disabledSort: true,
    style: { minWidth: "180px" },
    renderCell: ({ data }) => {
      const { reason, order_id } = data;
      const orderInfoList = [2, 29, 30];
      const reasonValue = reasonMap(reason?.reason);

      return (
        <Typography style={{ fontSize: "0.9rem", color: "#414141" }}>
          {reasonValue}
          {orderInfoList.includes(reason?.id) && (
            <strong style={{ color: "#000000c7" }}>{` #${order_id}`}</strong>
          )}
        </Typography>
      );
    }
  },
  {
    field: "batch_id",
    label: "Lote",
    disabledSort: true,
    style: { minWidth: "140px", maxWidth: "200px" }
  },
  {
    field: "created_by_name",
    label: "Responsável",
    disabledSort: true,
    style: { minWidth: "140px", maxWidth: "200px" }
  },
  {
    field: "seller",
    label: "Fornecedor",
    disabledSort: true,
    style: { minWidth: "180px", maxWidth: "300px" },
    formatter: value => value?.name
  },
  {
    field: "options",
    label: "",
    renderCell: ({ data }) =>
      !data.batch_id ? <OptionsMenu data={data} options={options} /> : null
  }
];

export const groupedByProductColumns = [
  {
    field: "product_base__name",
    label: "Produto Base",
    disabledSort: true,
    style: { minWidth: "200px", maxWidth: "350px" }
  },
  {
    field: "type_id",
    label: "Tipo",
    align: "center",
    disabledSort: true,
    style: { minWidth: "140px" },
    formatter: value => typeMapping(value)
  },
  {
    field: "total_quantity",
    label: "Quantidade Total",
    align: "center",
    disabledSort: true,
    style: { minWidth: "160px" },
    formatter: value => {
      if (!value && value !== 0) return "0";
      return new Intl.NumberFormat("pt-BR").format(
        parseFloat(value).toFixed(2)
      );
    },
    cellStyle: data => {
      if (data.total_quantity < 0) {
        return { color: "red" };
      }
    }
  },
  {
    field: "movement_count",
    label: "Nº de Movimentações",
    align: "center",
    disabledSort: true,
    style: { minWidth: "180px" },
    formatter: value => new Intl.NumberFormat("pt-BR").format(value || 0)
  }
];

export const groupedByReasonColumns = [
  {
    field: "reason__reason",
    label: "Motivo",
    disabledSort: true,
    style: { minWidth: "200px", maxWidth: "350px" },
    formatter: value => reasonMap(value)
  },
  {
    field: "type_id",
    label: "Tipo",
    align: "center",
    disabledSort: true,
    style: { minWidth: "140px" },
    formatter: value => typeMapping(value)
  },
  {
    field: "total_quantity",
    label: "Quantidade Total",
    align: "center",
    disabledSort: true,
    style: { minWidth: "160px" },
    formatter: value => {
      if (!value && value !== 0) return "0";
      return new Intl.NumberFormat("pt-BR").format(
        parseFloat(value).toFixed(2)
      );
    },
    cellStyle: data => {
      if (data.total_quantity < 0) {
        return { color: "red" };
      }
    }
  },
  {
    field: "movement_count",
    label: "Nº de Movimentações",
    align: "center",
    disabledSort: true,
    style: { minWidth: "180px" },
    formatter: value => new Intl.NumberFormat("pt-BR").format(value || 0)
  }
];

export const groupedByProductAndReasonColumns = [
  {
    field: "product_base__name",
    label: "Produto Base",
    disabledSort: true,
    style: { minWidth: "200px", maxWidth: "350px" }
  },
  {
    field: "reason__reason",
    label: "Motivo",
    disabledSort: true,
    style: { minWidth: "180px", maxWidth: "300px" },
    formatter: value => reasonMap(value)
  },
  {
    field: "type_id",
    label: "Tipo",
    align: "center",
    disabledSort: true,
    style: { minWidth: "140px" },
    formatter: value => typeMapping(value)
  },
  {
    field: "total_quantity",
    label: "Quantidade Total",
    align: "center",
    disabledSort: true,
    style: { minWidth: "160px" },
    formatter: value => {
      if (!value && value !== 0) return "0";
      return new Intl.NumberFormat("pt-BR").format(
        parseFloat(value).toFixed(2)
      );
    },
    cellStyle: data => {
      if (data.total_quantity < 0) {
        return { color: "red" };
      }
    }
  },
  {
    field: "movement_count",
    label: "Nº de Movimentações",
    align: "center",
    disabledSort: true,
    style: { minWidth: "180px" },
    formatter: value => new Intl.NumberFormat("pt-BR").format(value || 0)
  }
];

export const getColumns = (groupBy, options) => {
  const hasGroupByProduct = groupBy?.includes("product");
  const hasGroupByReason = groupBy?.includes("reason");

  if (hasGroupByProduct && hasGroupByReason) {
    return groupedByProductAndReasonColumns;
  }
  if (hasGroupByProduct) {
    return groupedByProductColumns;
  }
  if (hasGroupByReason) {
    return groupedByReasonColumns;
  }
  return getNormalColumns(options);
};
